import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { IoClose } from "react-icons/io5";
import { ToastContainer } from "react-toastify";
import { apiHeader, getData, postData } from "../helpers/ApiHelper";
import {
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../helpers/Reusable";
import { useContactStore } from "../stores/contactStore";
import _ from "lodash";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValuesServiceRequest = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
};

const initialValuesPublishWithUs = {
  firstName: "",
  qualification: "",
  email: "",
  mobileNumber: "",
  topicOfArticle: "",
  docArticle: "",
};

const initialValuesPartnerWithUs = {
  firstName: "",
  email: "",
  contactNumber: "",
  message: "",
};

const initialValuesAdvertiseWithUs = {
  fullName: "",
  email: "",
  contactNumber: "",
  city: "",
  message: "",
};

const initialValuesSubscribe = {
  firstName: "",
  lastName: "",
  email: "",
};

const initialValuesProvideFeedback = {
  firstName: "",
  email: "",
  contactNumber: "",
  message: "",
};

// Fromik Validation Schema
const schemaServiceRequest = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(onlyAlphabet, "First name is not valid"),
  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(onlyAlphabet, "Last name is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
});

const schemaPublishWithUs = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(onlyAlphabet, "Full name is not valid"),
  qualification: Yup.string().trim().required("Qualification is required"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  topicOfArticle: Yup.string().trim().required("Topic of article is required"),
  docArticle: Yup.string().trim().required("Attach article"),
});

const schemaPartnerWithUs = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(onlyAlphabet, "Full name is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  contactNumber: Yup.string()
    .trim()
    .required("Contact number is required")
    .matches(onlyIntRegExp, "Contact number is not valid")
    .min(10, "Contact number is not valid")
    .max(16, "Contact number is not valid"),
  message: Yup.string().trim(),
});

const schemaAdvertiseWithUs = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(onlyAlphabet, "Full name is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  contactNumber: Yup.string()
    .trim()
    .required("Contact number is required")
    .matches(onlyIntRegExp, "Contact number is not valid")
    .min(10, "Contact number is not valid")
    .max(16, "Contact number is not valid"),
  city: Yup.string().trim().required("City is required"),
  message: Yup.string().trim(),
});

const schemaSubscribe = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(onlyAlphabet, "First name is not valid"),
  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(onlyAlphabet, "Last name is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
});

const schemaProvideFeedback = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(onlyAlphabet, "Full name is not valid"),
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  contactNumber: Yup.string()
    .trim()
    .required("Contact number is required")
    .matches(onlyIntRegExp, "Contact number is not valid")
    .min(10, "Contact number is not valid")
    .max(16, "Contact number is not valid"),
  message: Yup.string().trim(),
});

const Footer = () => {
  const [isServiceRequestModalOpen, setIsServiceRequestModalOpen] =
    useState(false);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
  const [isPublishWithUsModalOpen, setIsPublishWithUsModalOpen] =
    useState(false);
  const [isPartnerWithUsModalOpen, setIsPartnerWithUsModalOpen] =
    useState(false);
  const [isAdvertiseWithUsModalOpen, setIsAdvertiseWithUsModalOpen] =
    useState(false);
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false);
  const [isProvideFeedbackModalOpen, setIsProvideFeedbackModalOpen] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [legalList, setLegalList] = useState([]);
  const contactList = useContactStore((s) => s.contactList);
  const { setContactList } = useContactStore();
  const staticIcons = {
    phone: "media/img/icon/basic/contactus-phone.svg",
    whatsapp: "media/img/icon/basic/contactus-whatsapp.svg",
    email: "media/img/icon/basic/contactus-mail.svg",
    form: "media/img/icon/basic/contactus-help.svg",
  };
  const ICON_MAP = {
    "Phone Number": staticIcons.phone,
    "Whatsapp": staticIcons.whatsapp,
    "Email": staticIcons.email,
    "E-Form": staticIcons.form,
  };
  //Contact lodash Subtitle Manage
  const CONTACT_CONFIG = {
    "Phone Number": {
      order: 1,
      subtitle: "To reach by phone, please call",
      icon: staticIcons.phone,
    },
    "Whatsapp": {
      order: 2,
      subtitle: "To connect via WhatsApp, click the icon below",
      icon: staticIcons.whatsapp,
    },
    "Email": {
      order: 3,
      subtitle: "For email communication",
      icon: staticIcons.email,
    },
    "E-Form": {
      order: 4,
      subtitle: "To submit e-Form",
      icon: staticIcons.form,
    },
  };

  //Filter
 const contactUsList = _.chain(contactList)
   .filter((item) => CONTACT_CONFIG[item.title])
   .sortBy((item) => CONTACT_CONFIG[item.title].order)
   .value();
  // Service Request Api Call
  const formikServiceRequest = useFormik({
    initialValues: initialValuesServiceRequest,
    validationSchema: schemaServiceRequest,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        message: values.message,
      };

      console.log(param);

      const response = await postData(
        "servicerequest/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Service Request");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Publish With Us Api Call
  const formikPublishWithUs = useFormik({
    initialValues: initialValuesPublishWithUs,
    validationSchema: schemaPublishWithUs,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = new FormData();

      param.append("firstName", values.firstName);
      param.append("qualification", values.qualification);
      param.append("email", values.email);
      param.append("mobileNumber", values.mobileNumber);
      param.append("topicOfArticle", values.topicOfArticle);
      param.append("article", values.docArticle);

      const response = await postData(
        "publishwithus/save",
        param,
        apiHeader(true)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Publish With Us");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Partner With Us Api Call
  const formikPartnerWithUs = useFormik({
    initialValues: initialValuesPartnerWithUs,
    validationSchema: schemaPartnerWithUs,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        email: values.email,
        mobileNumber: values.contactNumber,
        message: values.message,
      };

      console.log(param);

      const response = await postData(
        "partnerwithus/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Partner With Us");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Advertise with us Api Call
  const formikAdvertiseWithUs = useFormik({
    initialValues: initialValuesAdvertiseWithUs,
    validationSchema: schemaAdvertiseWithUs,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        fullName: values.fullName,
        email: values.email,
        mobileNumber: values.contactNumber,
        city: values.city,
        message: values.message,
      };

      console.log(param);

      const response = await postData(
        "advertisewithus/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Advertise With Us");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Subscribe Api Call
  const formikSubscribe = useFormik({
    initialValues: initialValuesSubscribe,
    validationSchema: schemaSubscribe,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
      };

      console.log(param);

      const response = await postData(
        "newsletter/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Subscribe");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Provide Feedback Api Call
  const formikProvideFeedback = useFormik({
    initialValues: initialValuesProvideFeedback,
    validationSchema: schemaProvideFeedback,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        firstName: values.firstName,
        email: values.email,
        mobileNumber: values.contactNumber,
        message: values.message,
      };

      console.log(param);

      const response = await postData("", param, apiHeader(false));

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal("Provide Feedback");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Opem Modal Popup Form Function
  const openModal = (type) => {
    document.body.style.overflowY = "hidden";
    if (type == "Service Request") {
      setIsServiceRequestModalOpen(true);
    } else if (type == "Contact Us") {
      setIsContactUsModalOpen(true);
    } else if (type == "Publish With Us") {
      setIsPublishWithUsModalOpen(true);
    } else if (type == "Partner With Us") {
      setIsPartnerWithUsModalOpen(true);
    } else if (type == "Advertise With Us") {
      setIsAdvertiseWithUsModalOpen(true);
    } else if (type == "Subscribe") {
      setIsSubscribeModalOpen(true);
    } else if (type == "Provide Feedback") {
      setIsProvideFeedbackModalOpen(true);
    }
  };

  // Close Modal Popup Form Function
  const closeModal = (type) => {
    document.body.style.overflowY = "";
    if (type == "Service Request") {
      setIsServiceRequestModalOpen(false);
      formikServiceRequest.resetForm();
    } else if (type == "Contact Us") {
      setIsContactUsModalOpen(false);
    } else if (type == "Publish With Us") {
      setIsPublishWithUsModalOpen(false);
      formikPublishWithUs.resetForm();
    } else if (type == "Partner With Us") {
      setIsPartnerWithUsModalOpen(false);
      formikPartnerWithUs.resetForm();
    } else if (type == "Advertise With Us") {
      setIsAdvertiseWithUsModalOpen(false);
      formikAdvertiseWithUs.resetForm();
    } else if (type == "Subscribe") {
      setIsSubscribeModalOpen(false);
      formikSubscribe.resetForm();
    } else if (type == "Provide Feedback") {
      setIsProvideFeedbackModalOpen(false);
      formikProvideFeedback.resetForm();
    }
  };

  // Fetch contact us list
 const fetchContactUsList = async () => {
   try {
     setLoading(true);

     const response = await getData("contactus/list", {}, apiHeader(false));

     if (
       String(response?.status) === "200" &&
       String(response.data?.status) === "200"
     ) {
       const contacts = response.data.data.list || [];
       setContactList(contacts);
     } else {
       toasterrormsg(response.data.message);
     }
   } catch (error) {
     toasterrormsg("Error loading contact information");
   } finally {
     setLoading(false);
   }
 };


  // Get static icon for contact type
 const getIcon = (title) => {
   return ICON_MAP[title] || staticIcons.form;
 };
 const getSubtitle = (title) => CONTACT_CONFIG[title]?.subtitle || "";


  // Render contact link based on type
  const renderContactLink = (contact) => {
    switch (contact.title) {
      case "Phone Number":
        return (
          <a href={`tel:${contact.detail}`}>
            <h2 className="form-title-y">{contact.detail}</h2>
          </a>
        );
      case "Whatsapp":
        return (
          <a
            href={contact.detail}
            target="_blank"
            rel="noopener noreferrer"
            className="form-title-y"
          >
            WhatsApp me
          </a>
        );
      case "Email":
        return (
          <a href={`mailto:${contact.detail}`}>
            <h2 className="form-title-y">{contact.detail}</h2>
          </a>
        );
      case "E-Form":
        return (
          <button
            onClick={() => {
              closeModal("Contact Us");
              openModal("Service Request");
            }}
            className="form-title-y"
          >
            Click here
          </button>
        );
      default:
        return <h2 className="form-title-y"></h2>;
    }
  };

  const fetchLegalList = async () => {
    const param = {};
    const response = await postData("legalflow/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list || [];
      setLegalList(data);
    } else {
      console.log(response?.data?.message);
    }
  };

  useEffect(()=>{
    fetchContactUsList();
    fetchLegalList();
  },[])

  return (
    <>
      <ToastContainer />
      {isServiceRequestModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Service Request")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[1%] flex items-center justify-between">
                <h1 className="hanson">Service request</h1>
                <IoClose
                  onClick={() => closeModal("Service Request")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <p className="mb-[3%] form-para">
                Welcome to the GCC Law Help! We are here at your service and our
                team is working diligently to resolve your queries. To work on
                your request, we would need few details from your end.
              </p>
              <div className="">
                <form onSubmit={formikServiceRequest.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter first name"
                        name="firstName"
                        id="firstName"
                        value={formikServiceRequest.values.firstName}
                        onChange={formikServiceRequest.handleChange}
                      />
                      {formikServiceRequest.touched.firstName &&
                        formikServiceRequest.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Last name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter last name"
                        name="lastName"
                        id="lastName"
                        value={formikServiceRequest.values.lastName}
                        onChange={formikServiceRequest.handleChange}
                      />
                      {formikServiceRequest.touched.lastName &&
                        formikServiceRequest.errors.lastName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.lastName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="email"
                        value={formikServiceRequest.values.email}
                        onChange={formikServiceRequest.handleChange}
                      />
                      {formikServiceRequest.touched.email &&
                        formikServiceRequest.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikServiceRequest.values.message}
                        onChange={formikServiceRequest.handleChange}
                        rows={3}
                      />
                      {formikServiceRequest.touched.message &&
                        formikServiceRequest.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikServiceRequest.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isContactUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Contact Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Contact us</h1>
                <IoClose
                  onClick={() => closeModal("Contact Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              {/* <div className="">
                <div className="mb-[3rem]">
                  <h1 className="mb-[2rem] form-title2-b">
                    You can reach us :
                  </h1>
                  <ul className="pl-[3rem] form-ul-disc-g">
                    <li className="form-ul-disc-g-li">
                      For any queries or service requests.
                    </li>
                    <li className="form-ul-disc-g-li">
                      To know more about our products and services.
                    </li>
                  </ul>
                </div>
                <div>
                  <h1 className="mb-[2rem] form-title2-b">
                    You can contact us through the following ways:
                  </h1>
                  <div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-phone.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">
                          To reach by phone, please call
                        </h1>
                        <a href="tel:9819222127">
                          <h2 className="form-title-y">9819222127</h2>
                        </a>
                      </div>
                    </div>
                    <div className="my-[3rem] lg:w-[60%] form-line"></div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-whatsapp.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">
                          To connect via WhatsApp, click the icon below
                        </h1>
                        <a
                          href="https://chat.whatsapp.com/LK86GdKTnD073Ut9HyI7mu"
                          target="_blank"
                          className="form-title-y"
                        >
                          WhatsApp me
                        </a>
                      </div>
                    </div>
                    <div className="my-[3rem] lg:w-[60%] form-line"></div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-mail.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">
                          For email communication
                        </h1>
                        <a href="mailto:gcchelplaw@gmail.com">
                          <h2 className="form-title-y">gcchelplaw@gmail.com</h2>
                        </a>
                      </div>
                    </div>
                    <div className="my-[3rem] lg:w-[60%] form-line"></div>
                    <div className="flex items-start gap-7 form-contactus-box">
                      <img
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/contactus-help.svg"
                        )}
                        alt=""
                      />
                      <div>
                        <h1 className="form-title3-b">To submit e-Form</h1>
                        <button
                          onClick={() => {
                            closeModal("Contact Us");
                            openModal("Service Request");
                          }}
                          className="form-title-y"
                        >
                          Click here
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="">
                <div className="mb-[3rem]">
                  <h1 className="mb-[2rem] form-title2-b">
                    You can reach us :
                  </h1>
                  <ul className="pl-[3rem] form-ul-disc-g">
                    <li className="form-ul-disc-g-li">
                      For any queries or service requests.
                    </li>
                    <li className="form-ul-disc-g-li">
                      To know more about our products and services.
                    </li>
                  </ul>
                </div>

                <div>
                  <h1 className="mb-[2rem] form-title2-b">
                    You can contact us through the following ways:
                  </h1>
                  <div>
                    {contactUsList.length === 0 ? (
                      <p className="text-muted">
                        No contact information available.
                      </p>
                    ) : (
                      contactUsList.map((contact, index) => (
                        <React.Fragment key={contact._id}>
                          <div className="flex items-start gap-7 form-contactus-box">
                            <img
                              src={toAbsoluteUrl(getIcon(contact.title))}
                              alt={contact.title}
                            />
                            <div>
                              <h1 className="form-title3-b">{getSubtitle(contact.title)}</h1>
                              
                              {renderContactLink(contact)}
                            </div>
                          </div>
                          {index < contactList.length - 1 && (
                            <div className="my-[3rem] lg:w-[60%] form-line"></div>
                          )}
                        </React.Fragment>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {isPublishWithUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Publish With Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[25%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Publish with us</h1>
                <IoClose
                  onClick={() => closeModal("Publish With Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikPublishWithUs.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter full name"
                        name="firstName"
                        id="firstName"
                        value={formikPublishWithUs.values.firstName}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.firstName &&
                        formikPublishWithUs.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Qualification
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter qualification"
                        name="qualification"
                        id="qualification"
                        value={formikPublishWithUs.values.qualification}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.qualification &&
                        formikPublishWithUs.errors.qualification && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.qualification}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Mobile number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter mobile number"
                        id="mobileNumber"
                        value={formikPublishWithUs.values.mobileNumber}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.mobileNumber &&
                        formikPublishWithUs.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.mobileNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email address
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email address"
                        id="email"
                        value={formikPublishWithUs.values.email}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.email &&
                        formikPublishWithUs.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Topic of article
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter topic of article"
                        name="topicOfArticle"
                        id="topicOfArticle"
                        value={formikPublishWithUs.values.topicOfArticle}
                        onChange={formikPublishWithUs.handleChange}
                      />
                      {formikPublishWithUs.touched.topicOfArticle &&
                        formikPublishWithUs.errors.topicOfArticle && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.topicOfArticle}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Attach article
                      </label>
                      <label
                        htmlFor="docArticle"
                        className={`flex justify-center gap-2 items-center cursor-pointer form-doc-label form-input ${
                          formikPublishWithUs.values.docArticle == ""
                            ? ""
                            : "form-doc-label-active"
                        }`}
                      >
                        <img
                          src={
                            formikPublishWithUs.values.docArticle == ""
                              ? toAbsoluteUrl(
                                  "media/img/icon/basic/upload-g.svg"
                                )
                              : toAbsoluteUrl(
                                  "media/img/icon/basic/upload-y.svg"
                                )
                          }
                          alt=""
                        />
                        <span className="">
                          {formikPublishWithUs.values.docArticle
                            ? formikPublishWithUs.values.docArticle.name
                            : "Choose file"}
                        </span>
                      </label>
                      <input
                        className="w-full hidden form-input"
                        type="file"
                        placeholder="Enter Topic Of Article"
                        name="docArticle"
                        id="docArticle"
                        // value={formikPublishWithUs.values.docArticle}
                        onChange={(e) =>
                          formikPublishWithUs.setFieldValue(
                            "docArticle",
                            e.target.files[0] || ""
                          )
                        }
                      />
                      {formikPublishWithUs.touched.docArticle &&
                        formikPublishWithUs.errors.docArticle && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPublishWithUs.errors.docArticle}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isPartnerWithUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Partner With Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Partner with us</h1>
                <IoClose
                  onClick={() => closeModal("Partner With Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikPartnerWithUs.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter full name"
                        name="firstName"
                        id="firstName"
                        value={formikPartnerWithUs.values.firstName}
                        onChange={formikPartnerWithUs.handleChange}
                      />
                      {formikPartnerWithUs.touched.firstName &&
                        formikPartnerWithUs.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="email"
                        value={formikPartnerWithUs.values.email}
                        onChange={formikPartnerWithUs.handleChange}
                      />
                      {formikPartnerWithUs.touched.email &&
                        formikPartnerWithUs.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter contact number"
                        name="contactNumber"
                        id="contactNumber"
                        value={formikPartnerWithUs.values.contactNumber}
                        onChange={formikPartnerWithUs.handleChange}
                      />
                      {formikPartnerWithUs.touched.contactNumber &&
                        formikPartnerWithUs.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikPartnerWithUs.values.message}
                        onChange={formikPartnerWithUs.handleChange}
                        rows={5}
                      />
                      {formikPartnerWithUs.touched.message &&
                        formikPartnerWithUs.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikPartnerWithUs.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isAdvertiseWithUsModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Advertise With Us")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Advertise with us</h1>
                <IoClose
                  onClick={() => closeModal("Advertise With Us")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikAdvertiseWithUs.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter full name"
                        name="fullName"
                        id="fullName"
                        value={formikAdvertiseWithUs.values.fullName}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.fullName &&
                        formikAdvertiseWithUs.errors.fullName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.fullName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email address
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email address"
                        id="email"
                        value={formikAdvertiseWithUs.values.email}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.email &&
                        formikAdvertiseWithUs.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter contact number"
                        name="contactNumber"
                        id="contactNumber"
                        value={formikAdvertiseWithUs.values.contactNumber}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.contactNumber &&
                        formikAdvertiseWithUs.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        City
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter city"
                        name="city"
                        id="city"
                        value={formikAdvertiseWithUs.values.city}
                        onChange={formikAdvertiseWithUs.handleChange}
                      />
                      {formikAdvertiseWithUs.touched.city &&
                        formikAdvertiseWithUs.errors.city && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.city}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikAdvertiseWithUs.values.message}
                        onChange={formikAdvertiseWithUs.handleChange}
                        rows={5}
                      />
                      {formikAdvertiseWithUs.touched.message &&
                        formikAdvertiseWithUs.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikAdvertiseWithUs.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isSubscribeModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Subscribe")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] lg:my-0 relative lg:top-[10%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[1%] flex items-center justify-between">
                <h1 className="hanson">Subscribe to our newsletter</h1>
                <IoClose
                  onClick={() => closeModal("Subscribe")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <p className="mb-[3%] form-para">
                Stay updated with the latest news, exclusive offers, and special
                updates in your inbox.
              </p>
              <div className="">
                <form onSubmit={formikSubscribe.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-3 gap-[2rem] gap-y-[1rem] mb-[5rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        First name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter first name"
                        name="firstName"
                        id="firstName"
                        value={formikSubscribe.values.firstName}
                        onChange={formikSubscribe.handleChange}
                      />
                      {formikSubscribe.touched.firstName &&
                        formikSubscribe.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikSubscribe.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Last name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter last name"
                        name="lastName"
                        id="lastName"
                        value={formikSubscribe.values.lastName}
                        onChange={formikSubscribe.handleChange}
                      />
                      {formikSubscribe.touched.lastName &&
                        formikSubscribe.errors.lastName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikSubscribe.errors.lastName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email address
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email address"
                        id="email"
                        value={formikSubscribe.values.email}
                        onChange={formikSubscribe.handleChange}
                      />
                      {formikSubscribe.touched.email &&
                        formikSubscribe.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikSubscribe.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="mb-[5rem]">
                    <h1 className="mb-[2rem] form-title2-b">Why subscribe?</h1>
                    <ul className="pl-[3rem] lg:pl-[5rem] form-ul-disc-g">
                      <li className="form-ul-disc-g-li">
                        Exclusive content - Get access to content that is not
                        available anywhere else.
                      </li>
                      <li className="form-ul-disc-g-li">
                        Special offers - Be the first to know about our special
                        promotions and discounts.
                      </li>
                      <li className="form-ul-disc-g-li">
                        Latest update - Stay informed about the latest news and
                        updates.
                      </li>
                    </ul>
                  </div>
                  <div className="mb-[5rem]">
                    <h1 className="mb-[2rem] form-title2-b">Privacy policy</h1>
                    <p className="form-para">
                      We respect your privacy. Your information is safe and will
                      never be shared.
                    </p>
                  </div>
                  <div className="mb-[5rem]">
                    <h1 className="mb-[2rerm] form-title2-b">
                      Unsubscribe anytime
                    </h1>
                    <p className="form-para">
                      You can unsubscribe anytime by clicking the link in the
                      footer of our emails.
                    </p>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Subscribe now</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isProvideFeedbackModalOpen == true && (
        <>
          <div
            onClick={() => closeModal("Provide Feedback")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[20%] md:my-[15%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">Provide feedback / Testimonial</h1>
                <IoClose
                  onClick={() => closeModal("Provide Feedback")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikProvideFeedback.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter full name"
                        name="firstName"
                        id="firstName"
                        value={formikProvideFeedback.values.firstName}
                        onChange={formikProvideFeedback.handleChange}
                      />
                      {formikProvideFeedback.touched.firstName &&
                        formikProvideFeedback.errors.firstName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikProvideFeedback.errors.firstName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="email"
                        value={formikProvideFeedback.values.email}
                        onChange={formikProvideFeedback.handleChange}
                      />
                      {formikProvideFeedback.touched.email &&
                        formikProvideFeedback.errors.email && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikProvideFeedback.errors.email}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter contact number"
                        name="contactNumber"
                        id="contactNumber"
                        value={formikProvideFeedback.values.contactNumber}
                        onChange={formikProvideFeedback.handleChange}
                      />
                      {formikProvideFeedback.touched.contactNumber &&
                        formikProvideFeedback.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikProvideFeedback.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Message
                      </label>
                      <textarea
                        placeholder="Enter message"
                        type="text"
                        className="w-full form-input"
                        id="message"
                        value={formikProvideFeedback.values.message}
                        onChange={formikProvideFeedback.handleChange}
                        rows={5}
                      />
                      {formikProvideFeedback.touched.message &&
                        formikProvideFeedback.errors.message && (
                          <div className="mt-4 error-msg">
                            <div className="">
                              {formikProvideFeedback.errors.message}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full h-max relative footer">
        <div className="w-[90%] relative z-[1] py-[3%] mx-auto flex flex-col gap-[10%] justify-center text-white footer-menu">
          {/* <div className="w-full text-center">
            <button
              onClick={() => openModal("Contact Us")}
              className="mb-[2rem] text-center"
            >
              Contact us
            </button>
          </div> */}
          <div className="w-full mb-[2rem] flex flex-wrap justify-center">
            <h1 className="w-full mb-[1rem] lg:mb-0 lg:w-[15%] text-center lg:text-end">
              Legal :
            </h1>
            {legalList.length > 0 ? (
              legalList.map((item) => (
                <Link
                  key={item._id}
                  to={"/legal"}
                  state={{ id: item._id }}
                  className="footer-submenu"
                >
                  {item.title}
                </Link>
              ))
            ) : (
              <>
                <Link to={"/privacypolicy"} className="footer-submenu">
                  Privacy policy
                </Link>
                <Link to={"/enduserlicenseagreement"} className="footer-submenu">
                  End user agreement
                </Link>
                <Link to={"/disclaimerandcopyrights"} className="footer-submenu">
                  Disclaimer & Copyrights
                </Link>
                <Link to={"/paymentterms"} className="footer-submenu">
                  Payment terms
                </Link>
                <Link
                  to={"/cancellationreturnrefundpolicy"}
                  className="footer-submenu"
                >
                  Cancellation policy
                </Link>
              </>
            )}
          </div>
          <div className="w-full mb-[2rem] flex flex-wrap justify-center">
            <h1 className="w-full mb-[1rem] lg:mb-0 lg:w-[15%] text-center lg:text-end">
              Support :
            </h1>
            <button
              onClick={() => openModal("Contact Us")}
              className="footer-submenu"
            >
              Contact Us
            </button>
            <button
              onClick={() => openModal("Service Request")}
              className="footer-submenu"
            >
              Service request
            </button>
            {/* <Link to={"/location"} className="footer-submenu">
              Location
            </Link> */}
            <button
              onClick={() => openModal("Publish With Us")}
              className="footer-submenu"
            >
              Publish with us
            </button>
            <button
              onClick={() => openModal("Partner With Us")}
              className="footer-submenu"
            >
              {" "}
              Partner with us
            </button>
            <button
              onClick={() => openModal("Advertise With Us")}
              className="footer-submenu"
            >
              Advertise with us
            </button>
            <button
              onClick={() => openModal("Subscribe")}
              className="footer-submenu"
            >
              Subscription
            </button>
            <button
              onClick={() => openModal("Provide Feedback")}
              className="footer-submenu"
            >
              Provide feedback
            </button>
          </div>
          <div className="w-full mb-[2rem] flex flex-wrap justify-center">
            <h1 className="w-full mb-[1rem] lg:mb-0 lg:w-[15%] text-center lg:text-end">
              Company :
            </h1>
            <Link to={"/aboutus#visionmission"} className="footer-submenu">
              Vision & Mission
            </Link>
            <Link to={"/aboutus#profile"} className="footer-submenu">
              Profile
            </Link>
            <Link to={"/location"} className="footer-submenu">
              Location
            </Link>
          </div>
        </div>
        <div className="w-[90%] relative z-[1] mx-auto pt-[5%] md:pt-[2%] pb-[5%] sm:pb-[2%] gap-10 items-center lg:gap-0 flex flex-col lg:flex-row">
          <div className="w-full text-center lg:text-start">
            <p className="copyright text-center">
              Copyright ©{" "}
              <span>
                <Link to={"/"}>GCC Law Help</Link>
              </span>{" "}
              | Designed & Developed by{" "}
              <span>
                <a href="https://xpertlab.com/" target="_blank">
                  XpertLab Technologies Private Limited
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
